/**
 * 仅渲染 Outlet 的组件
 * 用于没有独立页面的父路由（中间层路由）
 */
import { Outlet } from 'react-router-dom'

const OutletOnly: React.FC = () => {
  return <Outlet />
}

export default OutletOnly
